import { CookiesKeys } from '@/constants/enums/CookiesEnum';
import { useUserStore } from '@/stores/user';
import { setLoginStateCookie, setToken } from '@/utils/token';
import { UtilCommon } from '@/utils/utilCommon';
import type { NavigationGuardNext, RouteLocationNormalized, Router } from 'vue-router';

export default async function webview({
  to,
  from,
  next,
  router
}: {
  to: RouteLocationNormalized;
  from: RouteLocationNormalized;
  next: NavigationGuardNext;
  router: Router;
}) {
  const user = useUserStore();
  const cookie = UtilCommon.getCookie(CookiesKeys.WebViewToken);

  if (cookie) {
    user.setLoginState(cookie);

    // SSO應用: 設置 Token 及登入狀態 (root domain cookie)
    setToken(cookie);
    setLoginStateCookie(true);
  }

  return next();
}
